<template>
  <v-container fluid>
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md6
      >
        <v-card class="elevation-12 text-xs-center">
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title class="headline">Host a game</v-toolbar-title>
          </v-toolbar>
          <v-card-text>Enter a host code below to host a game. Select whether you want this tab to be the public or private view of the game.</v-card-text>
          <v-form ref="form">
            <v-card-actions>
              <v-text-field
                prepend-icon="videogame_asset"
                name="code"
                v-model="code"
                label="Game Code"
                required
                :rules="gameCodeRules"
              ></v-text-field>
            </v-card-actions>
            <v-layout
              align-center
              justify-center
            >
              <v-flex
                xs6
                class="pa-3"
              >
                <v-btn
                  color="grey"
                  dark
                  block
                  @click="navigateHost('private')"
                >Private Mode
                <v-icon right dark>lock</v-icon></v-btn>
              </v-flex>
              <v-flex
                xs6
                class="pa-3"
              >
                <v-btn
                  color="secondary"
                  dark
                  block
                  @click="navigateHost('public')"
                >Public Teams Mode
                <v-icon right dark>group</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "ChooseHostMode",
  data() {
    return {
      code: this.$route.query.code,
      gameCodeRules: [v => !!v || "Game Code is required"]
    };
  },
  methods: {
    navigateHost(mode) {
      if (this.$refs.form.validate()) {
        let name = mode === "public" ? "PublicTeamList" : "HostManager";
        this.$router.push({
          name: name,
          params: {
            code: this.code
          }
        });
      };
    }
  },
  created() {
    let mode = this.$route.query.mode;

    if (mode && this.code) {
      this.navigateHost(mode);
    }
  }
};
</script>